import React from "react";

const AddressEn = () => {
  return (
    <>
      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-map-marker-alt green-icons position-absolute"></i>
        <span className="d-block">Budapest Office: </span>
         Angyalföldi út 5/a. II.emelet 208. iroda<br />
         1134 Budapest
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-map-marker-alt green-icons position-absolute"></i>
        <span className="d-block">Szarvas Office: </span> Szabadság út 22.<br />
        5540 Szarvas
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-envelope-open green-icons position-absolute"></i>
        <span className="d-block">email: </span>{" "}
        <a href="mailto:info@dyar.hu"> 	info@dyar.hu</a>
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-phone-square green-icons position-absolute"></i>
        <span className="d-block">Phone:</span>{" "}
        <a href="Tel: +36300130511">+36300130511</a>
      </p>
      {/* End .custom-span-contact */}
      {/*
      <p className="open-sans-font custom-span-contact position-relative last-row-in-adress">
        <i className="fab fa-linkedin green-icons position-absolute"></i>
        <span className="d-block">Social:</span>{" "}
        <a href="https://linkedin.com">LinkedIn</a>
      </p>
      */}
      
    </>
  );
};

export default AddressEn;
